/**
 * Iterates over the given object, but rather than yielding a value,
 * a function is yielded that can be called with the the given object
 * *or* one of the same type and will return the iterated value.
 *
 * This makes it possible to iterate over structures in parallel.
 *
 * The callback function also has a property 'key' which can be used
 * to explicitly access the current key being iterated over.
 *
 * @callback getValue
 * @param {IterableCollection} obj
 * @returns {*} The iterated value (as would have been returned by
 *                  `values()`)
 *
 * @generator
 * @param {IterableCollection} obj
 * @yield {getValue}
 */
export default function *valueGetters (obj) {
  //eslint-disable-next-line no-unused-vars
  for (let [key, value] of this.entries(obj)) {
    let getter = sourceObject => this.valueForKey(sourceObject, key);
    getter.key = key;
    yield getter;
  }
}



// WEBPACK FOOTER //
// ./lib/rlink-collections/core/valueGetters.js